import React, { useState } from 'react'
import { isEmpty } from 'lodash'

import Select from '@/components/forms/Select'
import { Button } from '@/components/buttons/Button'
import { ErrorMessage } from '@/components/forms/ErrorMessage'
import { FormField } from '@/components/forms/FormField'
import { TextInput } from '@/components/forms/TextInput'

// Step 2 — the organization the agent belongs to (its org is derived from the
// agent user's organization). No org is preselected: pick an existing one or
// create one inline. Continue stays disabled until an org is chosen.
export const OrganizationStep = ({
  organizationOptions,
  organizationId,
  onSelectOrg,
  onCreateOrg,
  createOrgLoading,
  createOrgError,
}) => {
  const [creatingOrg, setCreatingOrg] = useState(false)
  const [orgName, setOrgName] = useState('')

  const handleCreateOrg = async () => {
    const created = await onCreateOrg({ name: orgName.trim() })
    if (created) {
      setCreatingOrg(false)
      setOrgName('')
    }
  }

  return (
    <div className="create-agent__step" data-testid="organization-step">
      <h2>Organization</h2>
      <p className="create-agent__hint">
        The agent&apos;s user account and call data live under the organization you pick.
      </p>

      {creatingOrg ? (
        <div className="field-stack">
          <FormField>
            <label htmlFor="org-name">New organization name</label>
            <TextInput
              id="org-name"
              value={orgName}
              onChange={(event) => setOrgName(event.target.value)}
            />
          </FormField>
          {createOrgError && <ErrorMessage content={createOrgError} />}
          <div className="create-agent__inline-actions">
            <Button small onClick={() => setCreatingOrg(false)} disabled={createOrgLoading}>
              Cancel
            </Button>
            <Button
              brand
              small
              loading={createOrgLoading}
              disabled={isEmpty(orgName.trim())}
              onClick={handleCreateOrg}
            >
              Create organization
            </Button>
          </div>
        </div>
      ) : (
        <div className="field-stack">
          <FormField>
            {/* No visible label — the step heading already says "Organization";
                aria-label keeps the field accessible. */}
            <Select
              inputId="org-select"
              aria-label="Organization"
              options={organizationOptions}
              value={organizationId}
              isClearable={false}
              placeholder="Select an organization…"
              onChange={(option) => onSelectOrg(option?.value ?? null)}
            />
          </FormField>
          <Button basic small onClick={() => setCreatingOrg(true)}>
            + Create new organization
          </Button>
        </div>
      )}
    </div>
  )
}
